import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import Form from "react-validation/build/form.js";
import { Card, CardBody, Input } from "reactstrap";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader.js";
import "../../assets/custom css/loadoverlay.scss";
import Alerts from "../../components/Alerts/alerts.js";
import ItemService from "./Item.service.js";
import AuthService from "../Authentication/auth.service.js";
import { useNavigate, useLocation } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { createGlobalStyle } from 'styled-components';
import PermissionAccess from '../../PermissionAccess/Access.js';
import Select from 'react-select';

const MAX_IMAGE_SIZE_BYTES = 650 * 1024;
const MAX_TOTAL_BODY_BYTES = 950 * 1024;


const imageStyle = {
  width: 'auto',
  height: '200px',
  objectFit: 'cover',
  margin: '0px auto',
};

const slideStyle = {};

const customSliderStyles = `
  .slick-prev,
  .slick-next {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    width: 30px;
    height: 30px;
    z-index: 1;
  }

  .slick-prev:hover,
  .slick-next:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }

  .slick-prev {
    left: 10px;
  }

  .slick-next {
    right: 10px;
  }

  .slick-prev:before,
  .slick-next:before {
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: white;
  }
`;

const GlobalStyle = createGlobalStyle`
  ${customSliderStyles}
`;

const DriverUpdationForm = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { state } = location;
  // Supports both old shape `state = row` and new shape `state = { row, listFilters }`
  const row = state?.row ?? state;
  const listFilters = state?.listFilters;
  const [loading, setLoading] = useState(false);
  const form = useRef();
  const [item_name, setItem_name] = useState(row?.item_name);
  const [item_code, setItem_code] = useState(row?.item_code);
  const [portal, setPortal] = useState(row?.portal);
  const [BaseUOM, setBaseUOM] = useState(row?.BaseUOM);
  const [description, setDescription] = useState(row?.description);
  const [weight, setWeight] = useState(row?.weight);
  const [price, setPrice] = useState(row?.price);
  const [status, setStatus] = useState(row?.status);
  const [categories, setCategories] = useState([]);
  const [Category, setCategory] = useState(row?.category || '');
  const [selectedImages, setSelectedImages] = useState(row?.Images || []);
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();
  const [errors, setErrors] = useState({});

  const stored_user = authData.userData;
  let business = []
  if (stored_user.businesses) {
    business = stored_user.businesses
  }

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    fetchCategory(0, 99999);
    //iph todo: 47
    //console.log(state)
  }, []);

  function fetchCategory(page_index, page_limit) {
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }
    const stored_user = authData.userData;
    let business = []
    if (stored_user.businesses) {
      business = stored_user.businesses
    }

    var getData = {
      functionName: "GetCategoryDropDown",
      "postData": {
        "offset": offset,
        "sort": {
          "_id": -1
        },
        "limit": page_limit,
        business_id: business,
        "noActiveMatch": true
      }
    }
    setLoading(true);
    ItemService.GetCategories(getData, authData.sessionID,).then((response) => {
      setLoading(false);
      //iph todo: 47
      //console.log("Get Category response:-", response)
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      }
      else {
        const allCategories = response.data.data.data || [];
        //iph todo: 47
        //console.log("allCategories", allCategories)
        const activeOnly = allCategories.filter((c) => (c?.Status || c?.Status) === 'Active');
        setCategories(activeOnly);
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."))
        }
      })
  };


  const estimateBase64BodyBytes = (images) =>
    (images || []).reduce((total, img) => total + (typeof img === 'string' ? img.length : 0), 0);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || []);
    event.target.value = null;
    if (files.length === 0) return;

    const oversized = files.filter((file) => file.size > MAX_IMAGE_SIZE_BYTES);
    if (oversized.length > 0) {
      const names = oversized.map((f) => `${f.name} (${(f.size / 1024).toFixed(0)}KB)`).join(', ');
      const message = `Image provided must be less than 650KB. Rejected: ${names}`;
      setErrors((prev) => ({ ...prev, images: message }));
      Alerts.swalErrorAlert(t(message));
    }

    const validFiles = files.filter((file) => file.size <= MAX_IMAGE_SIZE_BYTES);
    if (validFiles.length === 0) return;

    const currentBodyBytes = estimateBase64BodyBytes(selectedImages);
    const incomingBodyBytes = validFiles.reduce(
      (total, file) => total + Math.ceil(file.size * 4 / 3) + 100,
      0
    );
    if (currentBodyBytes + incomingBodyBytes > MAX_TOTAL_BODY_BYTES) {
      const message = "Total images size too large. Please remove existing images or use smaller files (total must stay under ~950KB) to fit the 1MB server limit.";
      setErrors((prev) => ({ ...prev, images: message }));
      Alerts.swalErrorAlert(t(message));
      return;
    }

    setErrors((prev) => {
      const next = { ...prev };
      if (oversized.length === 0) delete next.images;
      return next;
    });
    Promise.all(validFiles.map(file => convertToBase64(file)))
      .then(base64Images => {
        setSelectedImages(prevImages => [...prevImages, ...base64Images]);
      });
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };


  const sliderStyle = {
    width: '100%',
    maxWidth: '900px',
    margin: '0 auto',
  }
  const ImageSlideshow = ({ images, onRemove }) => {
    if (images.length === 0) return null;

    const removeButtonStyle = {
      position: 'absolute',
      top: '10px',
      right: '10px',
      background: 'rgba(255, 0, 0, 0.7)',
      color: 'white',
      border: 'none',
      borderRadius: '50%',
      width: '30px',
      height: '30px',
      cursor: 'pointer',
      zIndex: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '16px',
      fontWeight: 'bold',
    };

    if (images.length === 1) {
      return (
        <div style={{ ...sliderStyle, textAlign: 'center', position: 'relative' }}>
          <img src={images[0]} alt="Single Image" style={imageStyle} />
          <button
            onClick={() => onRemove(0)}
            style={removeButtonStyle}
          >
            X
          </button>
        </div>
      );
    }

    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      arrows: true,
    };

    return (
      <div style={{ ...sliderStyle, position: 'relative' }}>
        <Slider {...settings}>
          {images.map((image, index) => (
            <div key={index} style={{ position: 'relative' }}>
              <img src={image} alt={`Slide ${index + 1}`} style={imageStyle} />
            </div>
          ))}
        </Slider>
        {images.map((_, index) => (
          <button
            key={`remove-${index}`}
            onClick={() => onRemove(index)}
            style={removeButtonStyle}
            className="remove-button"
          >
            X
          </button>
        ))}
      </div>
    );
  };


  const removeImage = (index) => {
    setSelectedImages(prevImages => prevImages.filter((_, i) => i !== index));
  };


  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!item_name?.trim()) {
      formErrors.item_name = "Item Name is required";
      isValid = false;
    }
    if (!item_code?.trim()) {
      formErrors.item_code = "Item Code is required";
      isValid = false;
    }
    if (!portal?.trim()) {
      formErrors.portal = "Portal is required";
      isValid = false;
    }
    if (!BaseUOM?.trim()) {
      formErrors.BaseUOM = "Base UOM is required";
      isValid = false;
    }
    if (!description?.trim()) {
      formErrors.description = "Description is required";
      isValid = false;
    }
    // if (!weight) {
    //   formErrors.weight = "Weight is required";
    //   isValid = false;
    // }
    if (!(Number(price) > 0)) {
      formErrors.price = "Price must be greater than 0";
      isValid = false;
    }
    if (!status) {
      formErrors.status = "Status is required";
      isValid = false;
    }

    if (!Category) {
      formErrors.Category = "Category is required";
      isValid = false;
    }

    // Image validation conditional on portal
    const portalLower = (portal || '').toLowerCase();
    const imagesRequired = portalLower === 'both' || portalLower === 'customers';
    if (imagesRequired && selectedImages.length === 0) {
      formErrors.images = "At least one image is required for Customers/Both portal";
      isValid = false;
    }

    if (selectedImages.length > 0) {
      const totalBodyBytes = estimateBase64BodyBytes(selectedImages);
      if (totalBodyBytes > MAX_TOTAL_BODY_BYTES) {
        formErrors.images = `Total images size too large (${(totalBodyBytes / 1024).toFixed(0)}KB). Each image must be less than 650KB and total must stay under ~950KB to fit the 1MB server limit. Please remove or replace images.`;
        isValid = false;
      }
    }

    setErrors(formErrors);
    return isValid;
  };

  async function handleSubmit(e) {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    var requestData = {
      _id: row?._id,
      functionName: "UpdateItems",
      Images: selectedImages,
      item_name: item_name,
      item_code: item_code,
      portal: portal,
      BaseUOM: BaseUOM,
      description: description,
      weight: weight || 0,
      price: price,
      category: Category,
      status: status
    };

    setLoading(true);

    ItemService.save_item(requestData, authData.sessionID)
      .then((response) => {
        setLoading(false);
        if (response.data.status) {
          navigate("/items-list", {
            state: { filters: listFilters, highlightId: row?._id },
          });
          Alerts.swalSuccessAlert(response.data.message || t("Data Updated successfully."));
        } else {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          } else {
            Alerts.swalErrorAlert(response.data.message || t("Error: Can't update data at the moment. Please try again later."));
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        Alerts.swalErrorAlert(t("Network Operation failed."));
      });
  }

  return (
    <>
      <div className="app-main__outer">
        <div className="app-main__inner">
          <div className="app-page-title">
            <div className="page-title-wrapper justify-content-left">
              <div className="page-title-heading fw-bold">
                <div className="page-title-icon">
                  <i className="pe-7s-plus icon-gradient bg-happy-green" />
                </div>
                <div>
                  {t("Update Item")}
                  <div className="page-title-subheading">
                    {t('Fill the form below to update Items')}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <div className="col-md-6">
              <Card className="main-card mb-3">
                <CardBody>
                  <LoadingOverlay
                    tag="div"
                    active={loading}
                    styles={{ overlay: (base) => ({ ...base }) }}
                    spinner={<DNALoader />}
                  >
                    <Form onSubmit={handleSubmit} ref={form}>
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="item_name">{t("Item Name")} <span style={{ color: "red" }}>*</span></label>
                            <Input
                              type='text'
                              value={item_name}
                              onChange={(e) => setItem_name(e.target.value)}
                              className={`form-control ${errors.item_name ? 'is-invalid' : ''}`}
                              placeholder={t("Item Name")}
                              name="item_name"
                              id="item_name"
                            />
                            {errors.item_name && <div className="invalid-feedback">{errors.item_name}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="item_code">{t("Item Code")} <span style={{ color: "red" }}>*</span></label>
                            <Input
                              type='text'
                              value={item_code}
                              onChange={(e) => setItem_code(e.target.value)}
                              className={`form-control ${errors.item_code ? 'is-invalid' : ''}`}
                              placeholder={t("Item Code")}
                              name="item_code"
                              id="item_code"
                            />
                            {errors.item_code && <div className="invalid-feedback">{errors.item_code}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="portal">{t("Portal")} <span style={{ color: "red" }}>*</span></label>
                            <Input
                              type='select'
                              value={portal}
                              onChange={(e) => setPortal(e.target.value)}
                              className={`form-control ${errors.portal ? 'is-invalid' : ''}`}
                              placeholder={t("Portal")}
                              name="portal"
                              id="portal"
                            >
                              <option value="" disabled>{t("Select Portal")}</option>
                              <option value="customers">{t("Customers Portal")}</option>
                              <option value="doctors">{t("Doctors Portal")}</option>
                              <option value="both">{t("Both")}</option>

                            </Input>
                            {errors.portal && <div className="invalid-feedback">{errors.portal}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="BaseUOM">{t("Base UOM")} <span style={{ color: "red" }}>*</span></label>
                            <Input
                              type='text'
                              value={BaseUOM}
                              onChange={(e) => setBaseUOM(e.target.value)}
                              className={`form-control ${errors.BaseUOM ? 'is-invalid' : ''}`}
                              placeholder={t("Base UOM")}
                              name="BaseUOM"
                              id="BaseUOM"
                            />
                            {errors.BaseUOM && <div className="invalid-feedback">{errors.BaseUOM}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="description">{t("Description")} <span style={{ color: "red" }}>*</span></label>
                            <Input
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                              type='text'
                              className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                              placeholder={t("Description")}
                              name="description"
                              id="description"
                            />
                            {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="weight">{t("Weight (Grams)")}</label>
                            <Input
                              value={weight}
                              onChange={(e) => setWeight(e.target.value)}
                              type='text'
                              className={`form-control ${errors.Weight ? 'is-invalid' : ''}`}
                              placeholder={t("Weight")}
                              name="weight"
                              id="weight"
                            />
                            {errors.weight && <div className="invalid-feedback">{errors.weight}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="price">{t("Price")} <span style={{ color: "red" }}>*</span></label>
                            <Input
                              value={price}
                              onChange={(e) => setPrice(e.target.value)}
                              type='number'
                              className={`form-control ${errors.price ? 'is-invalid' : ''}`}
                              placeholder={t("Price")}
                              name="price"
                              id="price"
                            />
                            {errors.price && <div className="invalid-feedback">{errors.price}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="Category">{t("Category")} <span style={{ color: "red" }}>*</span></label>
                            <Select
                              id="Category"
                              name="Category"
                              options={categories.map(option => ({ value: option._id, label: option.Name }))}
                              value={categories.find(option => option._id === Category) ? { value: Category, label: categories.find(option => option._id === Category)?.Name } : null}
                              onChange={option => setCategory(option ? option.value : '')}
                              placeholder={t("Select Category")}
                              isClearable
                              classNamePrefix="react-select"
                              className={errors.Category ? 'is-invalid' : ''}
                            />
                            {errors.Category && <div className="invalid-feedback" style={{ display: 'block' }}>{errors.Category}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="status">{t("Status")} <span style={{ color: "red" }}>*</span></label>
                            <select
                              name="status"
                              id="status"
                              value={status}
                              className={`form-select form-control ${errors.status ? 'is-invalid' : ''}`}
                              onChange={(e) => setStatus(e.target.value)}
                            >
                              <option disabled={false} value="">{t('--Choose an option--')}</option>
                              <option key={'Active'} value={'Active'}> {'Active'}   </option>
                              <option key={'Inactive'} value={'Inactive'}> {'Inactive'}   </option>
                            </select>
                            {errors.status && <div className="invalid-feedback">{errors.status}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="form-group">
                            <label htmlFor="images">{t("Images")} </label>
                            <small className="form-text text-muted d-block mb-1">{t("Image provided must be less than 650KB")}</small>
                            <Input
                              type='file'
                              accept="image/*"
                              multiple
                              className={`form-control ${errors.images ? 'is-invalid' : ''}`}
                              name="images"
                              id="images"
                              onChange={handleFileChange}
                            />
                            {errors.images && <div className="invalid-feedback">{errors.images}</div>}
                          </div>
                        </div>
                      </div>
                      <br />
                      {selectedImages.length > 0 && (
                        <div className="row">
                          <div className="col-md-12 col-xl-12">
                            <ImageSlideshow images={selectedImages} onRemove={removeImage} />
                          </div>
                        </div>
                      )}
                      <br />
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <center>
                            <button type="button" onClick={() => navigate("/items-list", { state: { filters: listFilters } })} className="btn btn-outline-light btn-hover-shine me-3 mt-3">{t('Cancel')}</button>
                            <button type='submit' className="btn btn-custom-color btn-hover-shine me-3 mt-3">{t('Update data')}</button>
                          </center>
                        </div>
                      </div>
                    </Form>
                  </LoadingOverlay>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );


}

export default DriverUpdationForm;